import { STORAGE_COMPONENT_IDS } from '../../componentIds';
export class PlannerProductComponent {
    static id = STORAGE_COMPONENT_IDS.PlannerProductComponent;
    typeId = PlannerProductComponent.id;
    doStoreInSnapshot = true;
    serializable = false;
    productId;
    constructor(productId) {
        this.productId = productId;
    }
    eq() {
        return false;
    }
}
//# sourceMappingURL=PlannerProductComponent.js.map